import {  cpqAxiosWithToken } from '../http-common';
import { Congiguration } from '../Constants/AppConstants';

class QuoteService {

    getAllQuotesByOppurtunity(oppurtunityId, userId) {
        let url = `Quote/GetAllQuotes/?companyId=${Congiguration.CompanyId}&OpportunityId=${oppurtunityId}&userId=${userId}`
        if (oppurtunityId!=='0') {
            url = `Quote/GetAllQuotes/?companyId=${Congiguration.CompanyId}&OpportunityId=${oppurtunityId}&userId=${userId}`;
        }
        else {
            url = `Quote/GetAllQuotes/?companyId=${Congiguration.CompanyId}&userId=${userId}`
        }
        return cpqAxiosWithToken.get(url);
    }

    getOpportunityByUser(userId) {
        
        return cpqAxiosWithToken.get(`OpportunityDetails/GetOpportunityByUser/?companyId=${Congiguration.CompanyId}&userId=${userId}`);
    }
  

    saveOpportunityDetails(opportunity) {
       
        return cpqAxiosWithToken.post("OpportunityDetails/SaveOpportunityDetails", opportunity);
    }

    saveCountryHeadCount(countryHeadCount) {

        return cpqAxiosWithToken.post("Quote/UploadCountryHeadCounts", countryHeadCount);
    }

    validateCountryHeadCount(countryHeadCount) {

        return cpqAxiosWithToken.post("Quote/ValidateCountryHeadCounts", countryHeadCount);
    }

    getQuoteCountryHeadCounts(quoteId) {

        return cpqAxiosWithToken.get(`/Quote/GetQuoteCountryHeadCounts/?quoteId=${quoteId}`);
    }

    getAllInPrice(allInPrice) {

        return cpqAxiosWithToken.post("AllInPriceCalculation/GetAllInPrice", allInPrice);
    }

    saveQuoteDetails(quote) {

        return cpqAxiosWithToken.post("Quote/SaveQuoteDetails", quote);
    }

    getQuoteDetails(quoteId) {

        return cpqAxiosWithToken.get(`Quote/GetQuoteDetails/?quoteId=${quoteId}`);
    }

    getQuoteDetailsForBankOfHours(quoteId) {

        return cpqAxiosWithToken.get(`/Quote/GetQuoteDetailsForBankOfHours/?quoteId=${quoteId}`);
    }

    getDuplicateQuoteDetails(quoteId, userId) {

        return cpqAxiosWithToken.get(`/Quote/GetDuplicateQuoteDetails/?quoteId=${quoteId}&userId=${userId}`);
    }

    getQuoteHistory(quoteId) {

        return cpqAxiosWithToken.get(`/Quote/GetQuoteHistory/?quoteId=${quoteId}`);
    }

    getServiceDistribution(companyId, productId,productVariationId,quoteId) {

        return cpqAxiosWithToken.get(`UtilizationDistribution/GetUtilizationDistributions/?companyId=${companyId}&productId=${productId}&productVariationId=${productVariationId}&quoteId=${quoteId}`);
    }

    saveServiceDistribution(serviceDistribution) {

        return cpqAxiosWithToken.post("UtilizationDistribution/SaveUtilizationDistributions", serviceDistribution);
    }

    saveQuoteHistory(quoteHistory) {

        return cpqAxiosWithToken.post("/Quote/SaveQuoteHistory", quoteHistory);
    }

    updateQuoteStatus(quoteStatusId, quoteId, userId) {

        return cpqAxiosWithToken.post(`/Quote/UpdateQuoteStatus/?quoteStatusId=${quoteStatusId}&quoteId=${quoteId}&userId=${userId}`);
    }

    getSAMLeadership(roleId) {

        return cpqAxiosWithToken.get(`/Quote/GetSAMLeadership/?roleId=${roleId}`);
    }
    getUsersByRole(roleId) {

        return cpqAxiosWithToken.get(`/Quote/GetSAMLeadership/?roleId=${roleId}`);
    }

    getPendingApprovalRoles(quoteId, statusId) {

        return cpqAxiosWithToken.get(`/Quote/GetPendingApprovalRoles/?quoteId=${quoteId}&statusId=${statusId}`);
    }

    saveNote(newNote) {

        return cpqAxiosWithToken.post("/Quote/SaveNote", newNote);
    }
    GetQuotePricingDetails(quoteId) {

        return cpqAxiosWithToken.get(`Quote/GetQuotePricingDetails/?quoteId=${quoteId}`);
    }
    
    GetBlendedRevenueDistribution(quoteId) {

        return cpqAxiosWithToken.get(`Quote/GetBlendedRevenueDistribution/?quoteId=${quoteId}`);
    }
    SaveQuoteCalculationsNonEAP(nonEapQuoteCalulation) {

        return cpqAxiosWithToken.post("Quote/SaveQuoteCalculationsNonEAP", nonEapQuoteCalulation);
    }
    SaveQuoteCalculations(saveQuoteCalculationParam) {

        return cpqAxiosWithToken.post(`Quote/SaveQuoteCalculations?quoteId=${saveQuoteCalculationParam.quoteId}&userId=${saveQuoteCalculationParam.userId}`);
    }
    removeQuoteCountries(removeCountries) {

        return cpqAxiosWithToken.post(`/Quote/SaveDuplicateQuoteCountryHeadCount/?quoteId=${removeCountries.quoteId}&countryIds=${removeCountries.countryIds}`);
    }
    uploadRFPFile(quoteId,formData) {

        return cpqAxiosWithToken.post(`AzureBlob/UploadFile/?quoteId=${quoteId}`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
    }
    downloadRFPFile(fileName) {

        return cpqAxiosWithToken.get(`AzureBlob/DownloadFile/?fileName=${fileName}`,{ responseType: 'arraybuffer' });
    }

    saveDeliveryStaffProductivityVariation(deliveryStaffProductivityVariation)
    {
        return cpqAxiosWithToken.post("/Quote/SaveDeliveryStaffProductivityVariation", deliveryStaffProductivityVariation);
    }

    saveStaffCostDepartmentVariation(staffCostDepartmentVariation) {
        return cpqAxiosWithToken.post("/Quote/SaveStaffCostDepartmentVariation", staffCostDepartmentVariation);
    }

    saveSessionUsageComponentTypeVariation(sessionUsageComponentTypeVariation) {
        return cpqAxiosWithToken.post("/Quote/SaveSessionUsageComponentTypeVariation", sessionUsageComponentTypeVariation);
    }

    saveExternalCostsVariation(externalCostsVariation) {
        return cpqAxiosWithToken.post("/Quote/SaveExternalCostsVariation", externalCostsVariation);
    }


    getAllQuotesByQuoteIdsForVisualization(requestData) {
        return cpqAxiosWithToken.post('/Quote/QuotesForVisualization',requestData);
    }
    getQuotesForBundledQuotes(requestData) {
        return cpqAxiosWithToken.post(`/Quote/QuotesForBundle`,requestData);
    }

    saveBankOfHoursVariation(bankOfHoursVariation) {
        return cpqAxiosWithToken.post("/Quote/SaveBankOfHoursVariation", bankOfHoursVariation);
    }

    saveCountryUtilizationVariation(countryUtilizationVariation) {
        return cpqAxiosWithToken.post("/Quote/SaveCountryUtilizationVariation", countryUtilizationVariation);
    }

    calculateBundleDiscount(calculateDiscountParams) {
        return cpqAxiosWithToken.post("/Quote/CalculateBundle", calculateDiscountParams);
    }

    getAllBundlesByUserAndOpportunityId(bundleParams) {
        return cpqAxiosWithToken.get(`/Quote/GetAllBundlesByUserAndOpportunityId?opportunityId=${bundleParams.opportunityId}&userId=${bundleParams.userId}`);
    }

    getBundleDetailsByBundleId(bundleId) {
        return cpqAxiosWithToken.get(`/Quote/GetBundleDetailsByBundleId?bundleId=${bundleId}`);
    }

    getBundleUploadDataByBundleId(bundleId) {
        return cpqAxiosWithToken.get(`/Crm/GetCrmBundleOpportunityProductData?bundleId=${bundleId}`);
    }

    removeBundle(removeBundleParams) {
        return cpqAxiosWithToken.delete(`/Quote/RemoveBundle?bundleId=${removeBundleParams.bundleId}&userId=${removeBundleParams.userId}`);
    }

    refreshBundle(refreshBundleParams) {
        return cpqAxiosWithToken.post(`/Quote/RefreshBundle`, refreshBundleParams);
    }

    validateBundle(bundleId) {
        return cpqAxiosWithToken.get(`/Quote/ValidateBundle?bundleId=${bundleId}`);
    }

    duplicateBundle(duplicateBundleParams) {
        return cpqAxiosWithToken.post(`/Quote/DuplicateBundle`, duplicateBundleParams);
    }

    submitBundle(submitBundleParams) {
        return cpqAxiosWithToken.post(`/Quote/SubmitBundle`, submitBundleParams);
    }

    approveBundle(approveBundleParams) {
        return cpqAxiosWithToken.post(`/Quote/ApproveBundle`, approveBundleParams);
    }

    getAllBundles(opportunityId, userId) {
        let url = `/Quote/GetAllBundles?companyId=${Congiguration.CompanyId}&userId=${userId}`;
        if (opportunityId && opportunityId !== '0') {
            url = `/Quote/GetAllBundles?companyId=${Congiguration.CompanyId}&opportunityId=${opportunityId}&userId=${userId}`;
        }
        return cpqAxiosWithToken.get(url);
    }

    saveBundleNote(bundleNote) {        
        return cpqAxiosWithToken.post(`/Quote/SaveBundleNotes`, bundleNote);
    }

    getBundleNotes(bundleId) {
        return cpqAxiosWithToken.get(`/Quote/GetBundleNotes?bundleId=${bundleId}`);
    }

    getBundleDetailsForManageBundles(bundleDetailsParams) {
        
        return cpqAxiosWithToken.get(`/Quote/GetBundleDetailsForManageBundles?companyId=${Congiguration.CompanyId}&bundleId=${bundleDetailsParams.bundleId}&userId=${bundleDetailsParams.userId}`);
    }

    rejectBundle(rejectBundleObj) {
        return cpqAxiosWithToken.post(`/Quote/RejectBundle`, rejectBundleObj);
    }

    saveBundleName(saveBundleNameObj) {
        return cpqAxiosWithToken.post(`/Quote/SaveBundleName`, saveBundleNameObj);
    }

    saveCrmBundleId(saveCrmBundleIdObj) {
        return cpqAxiosWithToken.post(`/Quote/SaveCrmBundleId`, saveCrmBundleIdObj);
    }

    syncQuotes(userId) {
        return cpqAxiosWithToken.get(`/Quote/ReSyncQuotes?userId=${userId}`);
    }

    approveQuote(approveQuoteObj) {
        return cpqAxiosWithToken.post(`/Quote/Approve`, approveQuoteObj);
    }

    rejectQuote(rejectQuoteObj) {
        return cpqAxiosWithToken.post(`/Quote/Reject`, rejectQuoteObj);
    }

    validateQuote(validateObj) {
        return cpqAxiosWithToken.post(`/Quote/Validate`, validateObj);
    }

    validateBundleApproval(validateObj) {
        return cpqAxiosWithToken.post(`/Quote/ValidateBundleApproval`, validateObj);
    }

    getPendingApprovalRolesForBundle(bundleId, statusId) {

        return cpqAxiosWithToken.get(`/Quote/GetPendingApproverRolesForBundle/?bundleId=${bundleId}&statusId=${statusId}`);
    }

    checkApproversRequired(quoteId) {

        return cpqAxiosWithToken.get(`/Quote/CheckApproversRequired/?quoteId=${quoteId}`);
    }

    saveApprovalAssignments(assignmentsObj) {
        return cpqAxiosWithToken.post(`/Quote/SaveApprovalAssignments`, assignmentsObj);
    }
}

export default new QuoteService();